const callActionAsync = async <TResponse, TPayload = void>(
  action: (args: TPayload) => TResponse,
  actionPayload: TPayload,
  loaderToggler: (args: any) => boolean | void = () => {}
): Promise<TResponse> => {
  let result;

  try {
    loaderToggler(true);
    result = await action(actionPayload);
  } finally {
    loaderToggler(false);
  }

  return result;
};

export default callActionAsync;
